import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import ListItemText from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItemText';
import { dataAttrs, DataValueMap } from 'Helpers/Testing';
import { FDIcon, FDStack } from '@facet-wealth/design';
import { Box } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import useUserContext from 'Context/UserContext';

const useStyles = buildUseStyles('ThreadListItemContent', (theme) => ({
  root: {
  },
  preview: {
    flexGrow: 1,
    whiteSpace: 'nowrap',
  },
  text: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minWidth: 0,
  },
  unread: {
    fontWeight: theme.typography.fontWeightExtraBold,
    color: theme.palette.common.black,
  },
  memberPreviewText: {
    color: theme.palette.text.primary,
  },
}));

const ThreadListItemContent = ({
  threadResource,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { isAgent } = useUserContext();

  const isUnread = threadResource.isTruthy('isUnread');
  const isGroupMessage = threadResource.attr('threadMembers').resources().length > 2;
  const subject = threadResource.attr('subject');
  const memberPreviewText = `${threadResource.attr('threadMemberPreview')}${isGroupMessage ? ',...' : ''}`;
  const showRoutedThreadSubjectIcon = threadResource.isTruthy('isThreadRoutedOrPendingAssignment') && isAgent;

  return (
    <ListItemText
      className={classNames(classes.text, classes.preview)}
      primary={!showRoutedThreadSubjectIcon
        ? subject : (
          <FDStack direction={'row'} spacing={1} alignItems={'center'}>
            <FDIcon icon={'truckBolt'} size={'sm'} {...dataAttrs('subject-routing-icon')} />
            <Box className={classes.text}> {subject} </Box>
          </FDStack>
        )
    }
      primaryTypographyProps={{
        className: classNames(classes.text, { [classes.unread]: isUnread }),
        variant: 'h6',
        ...DataValueMap
          .init('messages-page-thread-list-item-subject')
          .append(DataValueMap.keyMap.dataResourceId, threadResource.id())
          .build(),
      }}
      secondaryTypographyProps={{
        className: classNames(classes.text, classes.memberPreviewText, { [classes.unread]: isUnread }),
        variant: 'body1',
        ...DataValueMap
          .init('messages-page-thread-list-item-members')
          .append(DataValueMap.keyMap.dataResourceId, threadResource.id())
          .build(),
      }}
      secondary={memberPreviewText}
    />
  );
};

ThreadListItemContent.defaultProps = {
};

ThreadListItemContent.propTypes = {
  threadResource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export { ThreadListItemContent };
